module.exports = __webpack_public_path__ + "img/34.9dfa340e.png";